<h3>Edit Timezone</h3>
<mat-dialog-content>
    <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Timezone</mat-label>
            <mat-select [(ngModel)]="timezone" [disabled]="!timezonesLoaded">
                <mat-option [value]="null">Select Timezone</mat-option>
                <mat-option *ngFor="let timezone of timezones" [value]="timezone.ianaName">
                    {{ timezone.displayName }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="timezone === null">Timezone is required</mat-error>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button class="metallic-text-btn-red" type="button" (click)="cancel.emit()"><mat-icon matPrefix>cancel</mat-icon>Canel</button>
    <button mat-flat-button class="metallic-text-btn-blue" type="button" (click)="save.emit(timezone)"><mat-icon matPrefix>save</mat-icon>Save</button>
</mat-dialog-actions>